import { Box, Button, Card, CardContent, CardHeader, IconButton, Menu, MenuItem, Modal, Pagination, Paper, Stack, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T_Inquery } from "../../common/model/InqueryModel";
import { useProgress } from "../../contexts/ProgressContextProvider";
import { T_Page } from "../../common/model/apiModel";
import apis from "../../common/apis";
import { T_Param } from "../../common/model/paramModle";
import { T_Error } from "../../common/model/errorModel";
import { T_Video } from "../../common/model/videoModel";
import YouTube from "react-youtube";
import { CButton, CCard, CCardHeader, CCol, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CFormInput, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow, CTable, CTableBody, CTableDataCell, CTableRow } from "@coreui/react";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import React from "react";

import MoreVertIcon from "@mui/icons-material/MoreVert"
import NeonModal from "../../component/neon/NeonModal";

export default function VideoList(){
    const navigator = useNavigate();
    const {alert,setAlert} = useAlert();
    
    const pagesize = 10;
    const [page,setPage] = useState(1);
    const [list,setList] =  useState<T_Video[] | null>(null);
    const {showProgress,setShowProgress} = useProgress();
    const [pageInfo,setPageInfo] = useState<T_Page>()

    const [idata,setIdata] = useState<T_Video>();
    const [visibleModal,setVisibleModal] = useState(false);
            
    const [selData,setSelData] = useState<T_Video>();
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
      };



      const deleteCheck = (item:T_Video) => {
        setAlert({
          ...alert,
          visible:true,
          title:"삭제확인",
          msg:"정말로 삭제하시겠습니까?",
          buttonList:[{
            variant:"contained",
            text:"예",
            onPress:()=>{
              deleteVideo(item);
            }
          }
            ,
            {
              text:"아니요",
              variant:"outlined",
              onPress:()=>{
                setAlert({...alert,visible:false})
              }
            }
          ]
        })
      
      }
      
      const deleteVideo = async (item:T_Video) => {
        console.log("request:",selData)
        const result = await apis.video.videoDelete(item);
        console.log(result)
        if(result.code=="1"){
        //  console.log("bbb")
          setAlert({...alert,title:"확인",visible:true,msg:"삭제되었습니다."})
        }else{
          console.log(result.msg)
          setAlert({...alert,title:"확인",visible:true,msg:"삭제중 오류가 발생했습니다."})
        }
        getList();
      }
      

    const getList = useCallback(async () => {
        try {
          setShowProgress(true);
          const result = await apis.video.videoList(
            {
              page:Number(page),
              pagesize:pagesize,
            }
          );
          console.log("resut:",result)
            if(result.code=="1"){
            
                setList(result.data.list);
                setPageInfo(result.data);
                setShowProgress(false);
    
            }else{
                 
              setShowProgress(false);
            }
    
       
    
        } catch (err: any) {
          setShowProgress(false);
        }
      }, [page]);

      useEffect(() => {
          getList();
      }, [page]);
    

const updateData = async() =>{

  setAlert({
    ...alert,
    visible:true,
    title:"확인",
    msg:"정말로 수정하시겠습니까?",
    buttonList:[{
      text:"예",
      onPress:async()=>{
        setAlert(initialAlert);
        const result = await apis.video.videoEdit(selData);
        if(result.code=="1"){
          //  console.log("bbb")
            setIsModal(false);
            setAlert({...alert,title:"확인",visible:true,msg:"수정 되었습니다."})
            getList();
          }else{
            console.log(result.msg)
            setIsModal(false);
            setAlert({...alert,title:"확인",visible:true,msg:"수정중 오류가 발생했습니다."})
          }

      }
    }
      ,
      {
        text:"아니요",
        variant:"outlined",
        onPress:()=>{
          setAlert({...alert,visible:false})
        }
      }
    ]
  })


}

      
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
  }));

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [menuRow, setMenuRow] = useState<number | null>(null)
  const open = Boolean(anchorEl);
  const handleClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
    setAnchorEl(e.currentTarget)
    setMenuRow(idx)
  }
  const handleClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };
  const handleModalClose = () => {
    setIsModal(false);
  };

  const handleEdit = (idx:any) => {
    console.log("item:",idx)
      setIsModal(true);
      setAnchorEl(null);
  }
  const handleDel = (idx:any) => {
    console.log("item:",idx)

  }
  const [isModal,setIsModal] = useState(false);
      
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 0,
  };
    return(
      <>
   <Card sx={{width:'100%'}} >
        <CardHeader sx={{pr:5,pb:0,mb:0}} title="영상관리"    action={
          <Button variant="outlined" onClick={()=>{
            navigator("/video/insert")
          }}>
           등록
          </Button>
        } />
       
        <CardContent>
        <TableContainer component={Paper}>
      <Table  aria-label="simple table">
        <TableHead>
     
        </TableHead>
        <TableBody>
        {list?.map((item, idx) => (
          <TableRow
          key={idx}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            "& .MuiTableCell-root": {
              display: { xs: "block", sm: "table-cell" },
            },
          }}
        >
          <TableCell sx={{ width: { sm: 240, xs: "100%" }, p: 1 }}>
            <YouTube videoId={item.videoId} opts={{ width: "100%", height: "200" }} />
          </TableCell>
          <TableCell sx={{ flex: 1, p: 1 }}>
          <Card>
              <CardHeader
                title={item.title}
                action={
                  <>
                    <IconButton
                      aria-label="menu"
                      onClick={(e) => handleClick(e, idx)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === idx}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem
                        onClick={() => {

                          handleClose()
                          setSelData(item);
                          handleEdit(item.idx)
                      
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async() => {
                          handleClose()
                          deleteCheck(item);
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
                  </>
                }
              />
              <CardContent>{item.contents}</CardContent>
            </Card>
          </TableCell>
      </TableRow>

      ))}
        </TableBody>
      </Table>
    </TableContainer>
      <Stack  direction="row"
              justifyContent="flex-end"
              alignItems="center" sx={{pt:5,justifyContent:'center',alignContent:'center',justifyItems:'center',alignItems:'ceter'}}>
      <Pagination count={pageInfo?.pages} showFirstButton showLastButton boundaryCount={2} onChange={handleChange}/>
      </Stack>
        </CardContent>

        <NeonModal
          open={isModal}
          onClose={handleModalClose}
          title="영상수정"
          btnList={[
                {
                  text:"예"
                  ,variant:'contained'
                  ,onPress:()=>{
                    updateData();
                  }
                },
                {
                  text:"아니오"
                  ,onPress:()=>{
                    handleModalClose();
                  }
                }

          ]}
          content={  <Table>
            <TableBody>
              <TableRow>
              <TableCell>제목</TableCell>
              <TableCell>
                <TextField fullWidth size="small" value={selData?.title} onChange={(event:any)=>{
                          setSelData({...selData,title:event.target.value})
                }}   />
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell>비디오아이디</TableCell>
              <TableCell>
                <TextField fullWidth size="small"  value={selData?.videoId} onChange={(event:any)=>{
                          setSelData({...selData,videoId:event.target.value})
                }}/>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell>내용</TableCell>
              <TableCell>
                <TextField fullWidth size="small" rows={3} multiline value={selData?.contents} onChange={(event:any)=>{
                          setSelData({...selData,contents:event.target.value})
                }} />
              </TableCell>
              </TableRow>
            </TableBody>
          </Table>}
        />

        {/* <Modal
        open={isModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Card>
            <CardHeader title="영상 수정" style={{textAlign:'center'}}></CardHeader>
            <CardContent>
            <Table>
              <TableBody>
                <TableRow>
                <TableCell>제목</TableCell>
                <TableCell>
                  <TextField fullWidth size="small" value={selData?.title} onChange={(event:any)=>{
                            setSelData({...selData,title:event.target.value})
                  }}   />
                </TableCell>
                </TableRow>
                <TableRow>
                <TableCell>비디오아이디</TableCell>
                <TableCell>
                  <TextField fullWidth size="small"  value={selData?.videoId} onChange={(event:any)=>{
                            setSelData({...selData,videoId:event.target.value})
                  }}/>
                </TableCell>
                </TableRow>
                <TableRow>
                <TableCell>내용</TableCell>
                <TableCell>
                  <TextField fullWidth size="small" rows={3} multiline value={selData?.contents} onChange={(event:any)=>{
                            setSelData({...selData,contents:event.target.value})
                  }} />
                </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <div style={{textAlign:'center',marginTop:7}}>         <Button variant="contained" onClick={updateData}>수정</Button> <Button onClick={handleModalClose}>취소</Button></div>
            </CardContent>
            
          </Card>
        </Box>
</Modal> */}
  
      </Card>


  
      </>
    )
}